module.exports = __webpack_public_path__ + "static/img/2.4f70112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Chengtun/2.jpg
// module id = Ay9l
// module chunks = 0